import "./index.less";

import { useState } from "react";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import classnames from "classnames";
import { TStoreData, TFlowItem } from "@/interface";

import SelectOrigin from "@/layout/components/selectOrigin";
import SwitchHostModal from "@/layout/components/switch-host-modal";
import menuAct from "../../image/button-bg.png";
import menuOldAct from "../../image/button-l-bg.png";
import SysConf from "@/conf/sys.map.config.js";
import { Tooltip } from "antd";

import { APP_PORTAL } from "@/interface";
import { canSwitchHost } from "@/util/host";
import { MAP_TENANT_FIRST_CODE, TENANT_ENV } from "@/constants/tenants";
import { useLogUtil } from "@/util/log";
import logo from "./image.png";

const Icons = require("@ant-design/icons");

const oldMenuStyle = {
    oldMenu: {
        width: 130,
    },
    oldMenuItem: {
        width: 130,
    },
};

const SideMenu = withRouter((props) => {
    const { history } = props;
    const [showHostModal, setShowHostModal] = useState(false);
    const storeData = useSelector((data: TStoreData) => {
        return {
            flow: data?.flow || [],
            other: data?.other || [],
            flowAndOtherActive: data?.flowAndOtherActive || "",
            customRecord: data?.customRecord,
            firstTenant: data?.firstTenant || {},
        };
    });
    const { log } = useLogUtil();

    const { flow, other, flowAndOtherActive, firstTenant } = storeData;

    const isJDDJ =
        MAP_TENANT_FIRST_CODE[TENANT_ENV.JDDJ] == firstTenant.tenantCode;

    // TODO: setTimeout 得处理；解决内存溢出问题
    // https://github.com/umijs/qiankun/issues/222
    const flowClick = async (flowItem: TFlowItem) => {
        // console.log("gyp flowClick", flowItem);

        log({
            eventId: "First_Level_Menu_Click",
            eventParams: {
                erp: sessionStorage.getItem("erp"),
                tenantCode: sessionStorage.getItem("tenantCode"),
                title: flowItem.title,
                url: flowItem.url,
            },
        });

        setTimeout(() => {
            const subMenu = flowItem?.subMenu || [];
            let url = "";
            if (!subMenu?.length) {
                if (flowItem?.url) {
                    // history.push(flowItem?.url);
                    url = flowItem?.url;
                } else {
                    /* TODOSAAS: 接入saas菜单 */
                    // message.warn("暂无该流程权限");
                    // history.push("/home");
                }
            } else {
                /* TODO: 初始化点击最外层渲染 */
                url = getUrl(subMenu);
            }

            history.push(
                url?.indexOf("http") !== -1
                    ? `/iframe-view/${encodeURIComponent(url)}`
                    : url
            );
        }, 0);
    };

    const getUrl = (menuList: any) => {
        if (menuList?.[0]?.url) {
            return menuList?.[0]?.url;
        } else if (menuList?.[0]?.children) {
            return getUrl(menuList?.[0]?.children);
        }
    };
    const openTenantDialog = () => {
        setShowHostModal(true);
        console.log(showHostModal);
    };

    const oldMenu = localStorage.getItem("crmUserMenu") === "?old=true";

    return (
        <div
            className={`lr-layout-main-menu`}
            style={oldMenu ? oldMenuStyle.oldMenu : {}}
        >
            <div
                className={`lr-layout-logo-box`}
                onClick={() => openTenantDialog()}
            >
                <SelectOrigin />
                <div className="lr-layout-content">
                    {firstTenant.appIcon && (
                        <img
                            src={firstTenant?.appIcon}
                            alt={firstTenant?.appName}
                            className="lr-layout-logo"
                        />
                    )}
                    <span className={classnames('lr-layout-title',
                        {
                            'hasIcon': firstTenant?.appIcon,
                        })}>
                        {firstTenant?.appName || SysConf.title}
                    </span>
                </div>

                <div className={`lr-layout-slogan`}>{SysConf.slogan}</div>
            </div>
            <div
                className={`lr-layout-main-menu-list`}
                style={{
                    height:
                        SysConf.name === APP_PORTAL.CRM
                            ? "calc(100vh - 156px)"
                            : "",
                }}
            >
                {flow.map((menu, index) => {
                    /* const Icon = Icons[menu.icon]; */
                    return (
                        <div
                            key={menu.key}
                            onClick={() => flowClick(menu)}
                            style={oldMenu ? oldMenuStyle.oldMenuItem : {}}
                            className={`lr-layout-main-menu-item ${flowAndOtherActive === menu.key
                                ? "lr-layout-main-menu-item-active"
                                : ""
                                }`}
                        >
                            <img
                                src={oldMenu ? menuOldAct : menuAct}
                                className={"lr-layout-main-menu-item-bg"}
                                alt=""
                            />
                            <div className={`lr-layout-main-menu-item-word`}>
                                {menu.title.length > 7 ? (
                                    <Tooltip
                                        onVisibleChange={() => { }}
                                        placement="topRight"
                                        title={menu.title}
                                    >
                                        {/* <Icon /> */}
                                        {`${menu.title.slice(0, 7) +
                                            (menu.title.length >= 7
                                                ? "..."
                                                : "")
                                            }`}
                                    </Tooltip>
                                ) : (
                                    <>
                                        {/* <Icon /> */} {menu.title}
                                    </>
                                )}
                            </div>
                        </div>
                    );
                })}
                {other.map((menu, otherKey) => {
                    /* const Icon = Icons[menu.icon]; */
                    return (
                        <>
                            <div className={`lc-layout-main-menu-line`} />
                            <div
                                key={menu.key}
                                onClick={() => flowClick(menu)}
                                className={`lr-layout-main-menu-item ${flowAndOtherActive === menu.key
                                    ? "lr-layout-main-menu-item-active"
                                    : ""
                                    }`}
                            >
                                <img
                                    src={oldMenu ? menuOldAct : menuAct}
                                    className={"lr-layout-main-menu-item-bg"}
                                    alt=""
                                />
                                <div
                                    className={`lr-layout-main-menu-item-word`}
                                >
                                    {/* <Icon /> */} {menu.title}
                                </div>
                            </div>
                        </>
                    );
                })}
            </div>
            {canSwitchHost && (
                <SwitchHostModal
                    open={showHostModal}
                    onOk={() => setShowHostModal(false)}
                    onCancel={() => setShowHostModal(false)}
                />
            )}
        </div>
    );
});

export default SideMenu;
